import { Cents } from '@fox/atoms';
import { createContext, useContext } from 'react';
import { FormFinancialLineItem } from '../contracts';

/**
 * A context to let the payment block and the payment method components interact
 */
export const FormPaymentContext = createContext<
	| {
			totalPayNotImmediate: Cents;
			lineItemsDataNotImmediate: FormFinancialLineItem[];
			lineItemsDataImmediate: FormFinancialLineItem[];
			totalPayImmediate: Cents;
			grandTotal: Cents;
			submitForm?: (result?: unknown) => Promise<void>;
	  }
	| undefined
>(undefined);
FormPaymentContext.displayName = 'PaymentAmountContext';
export function useFormPaymentContext() {
	const context = useContext(FormPaymentContext);

	if (!context) throw new Error('Missing payment amount context');

	return context;
}
